export class MensagensDeErro {
    static mensagens = {
      menor16Anos: "Menores de 16 anos não podem se cadastrar, para mais informações leia o <b>regulamento</b>.",
      telefoneNaoDisponivel: "Telefone não disponível.",
      emailNaoDisponivel: "O email inserido não está disponível.",
      required: "Campo obrigatório!",
      responsavelInvalido: "Responsável não cadastrado no programa.",
      email: "Email inválido!",
      minlength: "Campo inválido.",
      telefoneInvalido: "Telefone inválido!",
      pattern: "Campo inválido.",
      cpf: "CPF inválido.",
      responsavelNaoCadastrado: "Responsável não cadastrado no programa.",
    };
  
    static obterMensagem(chave: string): string {
      let mensagem = MensagensDeErro.mensagens[chave] || 'Erro desconhecido.';
      return mensagem;
    }
  }
  